import { useContext } from 'react';
import { StepInputDataContext } from '../context/StepInputDataContext/StepInputDataContext';

export const useStepInputData = () => {
  return useContext(StepInputDataContext);
};
